import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '@core/core.module';
import { ContinuesLaterComponent } from './continues-later.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [ContinuesLaterComponent],
  exports: [ContinuesLaterComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CoreModule, FontAwesomeModule, TranslateModule]
})
export class ContinuesLaterModule { }
